/** @jsx jsx */
import { gql } from '@apollo/client';
import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';

export default function ProductName({ shortName, vintage }) {
  if (!shortName) return null;
  return (
    <React.Fragment>
      <span className="notranslate">
        {shortName}
        {vintage && <span sx={{ opacity: 0.7 }}> {vintage}</span>}
      </span>
    </React.Fragment>
  );
}

export const fragment = graphql`
  fragment bb_ProductName on Bottlebooks_Product {
    shortName
    ... on Bottlebooks_Wine {
      vintage(removeNonVintage: true)
    }
  }
  fragment ProductName on Product {
    shortName
    vintage(removeNonVintage: true)
  }
`;

export const ProductNameFragment = gql`
  fragment ProductName on Product {
    shortName
    ... on Wine {
      vintage(removeNonVintage: true)
    }
  }
`;
